import type { AppID } from "@tiendanube/nube-sdk-internal-types";
import { dispatchInternalMessage } from "../../messages";

export function createWorkerNavigate(
	appId: AppID,
): (route: `/${string}`) => void {
	return (route: `/${string}`) => {
		dispatchInternalMessage(appId, "internal:navigate", { route });
	};
}
